import { ReactFlowState, useStore } from 'reactflow';

export const MIN_ZOOM_TO_SHOW = 0.25;
export const MIN_ZOOM_TO_TRUNCATE = 0.5;
export const MIN_HOVER_SCALE = 0.6;

const zoomSelector = (s: any) => s.transform[2];

/**
 * Avoid using this in a node or edge!
 */

const lastZoom: { zoom: number; timestamp: number } = { zoom: 1, timestamp: 0 };

const DEBOUNCE_ZOOM_MILLIS = 350;

function getZoomLevelDebounced(s: ReactFlowState) {
  const now = Date.now();
  if (lastZoom.timestamp + DEBOUNCE_ZOOM_MILLIS < now) {
    lastZoom.timestamp = now;
    lastZoom.zoom = zoomSelector(s);
  }
  return lastZoom.zoom;
}

export const useZoomLevelDebounced = () => {
  return useStore(getZoomLevelDebounced);
};

function getIsZoomLevelQuarter(s: ReactFlowState) {
  return zoomSelector(s) <= MIN_ZOOM_TO_SHOW;
}

function getIsZoomLevelHalf(s: ReactFlowState) {
  return zoomSelector(s) <= MIN_ZOOM_TO_TRUNCATE;
}

/**
 * Avoid using this in a node or edge!
 */
export const useIsZoomLevelQuarter = () => {
  return useStore(getIsZoomLevelQuarter);
};

/**
 * Avoid using this in a node or edge!
 */
export const useIsZoomLevelHalf = () => {
  return useStore(getIsZoomLevelHalf);
};
